import { IconButton, Tooltip } from "@mui/material";

import { Videocam, VideocamOff } from "@mui/icons-material";

interface VideoModalButtonProps {
    onClick: () => void;
}

export const EnabledVideoModalButton = ({ onClick }: VideoModalButtonProps) => {
    return (
        <Tooltip title="Play Video">
            <IconButton aria-label="open-video-modal" onClick={onClick}>
                <Videocam />
            </IconButton>
        </Tooltip>
    );
};

export const DisabledVideoModalButton = () => {
    return (
        <Tooltip title="No video available">
            <span>
                <IconButton aria-label="video-modal-off" disabled>
                    <VideocamOff />
                </IconButton>
            </span>
        </Tooltip>
    );
};
